module.exports = __webpack_public_path__ + "img/01-trx-before.c4d73550.jpg";